// extracted by mini-css-extract-plugin
export var container = "ShowedIndex-module--container--3Xhyc";
export var text = "ShowedIndex-module--text--3S_F-";